import React from 'react'
import { Switch, Route } from 'react-router-dom'

import Login from './Login'
import Signup from './Signup'
import AcceptInvitation from './AcceptInvitation'

export default function Auth() {
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/signup" component={Signup} />
      <Route path="/invitations/:invitationId" component={AcceptInvitation} />
    </Switch>
  )
}
